import { Sheet, Typography } from "@mui/joy";
import { SxProps } from "@mui/joy/styles/types";
import CustomCard from "components/common/CustomCard";
import React from "react";

export default function ThoughtMapCard({
  label,
  labelPostfix,
  content,
  labelBackgroundColor,
  sx,
}: {
  label: string;
  labelPostfix?: string;
  content?: React.ReactNode;
  labelBackgroundColor: string;
  sx?: SxProps;
}) {
  return (
    <CustomCard sx={sx}>
      <Sheet
        sx={{
          backgroundColor: labelBackgroundColor,
          py: "8px",
          textAlign: "center",
        }}
      >
        <Typography fontWeight="md" color={"negative"}>
          {label}
          {labelPostfix && ` ${labelPostfix}`}
        </Typography>
      </Sheet>
      <Sheet
        sx={{
          backgroundColor: "transparent",
          p: "16px",
          textAlign: "center",
          height: "100%",
        }}
      >
        {content}
      </Sheet>
    </CustomCard>
  );
}
